var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticulLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1472.05 1460.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5555f9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.76,600.52,434.31,443.28v964.27a730.75,730.75,0,0,0,172.38,53.17V338.46l123-74.83L865.3,342.58V1460.73a730.93,730.93,0,0,0,172.39-53.15V442.92L1296.3,593.49V1213.3A733.1,733.1,0,0,0,1472.05,736c0-406.5-329.53-736-736-736S0,329.53,0,736a733,733,0,0,0,175.76,477.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticulLogo);
export default __webpack_public_path__ + "static/media/verticul_logo.d1cac18e41487802a9196c01cb230592.svg";
export { ForwardRef as ReactComponent };